export default {
    type: 'numeric',
    format: {
        decimals: 3,
        min: 0,
        max: 10
    },
    default: {
        logic: 'min',
        rating: 'value'
    },
    setting: {
        logic: ['match', 'min', 'max', 'range', 'tolerance'],
        rating: ['value', 'band']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Community Rating',
        category: 'BGG',
        description: 'Community average rating of the game.',
        summarise: {
            prefix: 'BGG rating'
        }
    }
}